import { mapState } from 'vuex';
import Promocode from '@/components/classes/Promocode';

export default {
  data() {
    return {
      promocode: null,
    };
  },
  methods: {
    getPromocode(code, targetType) {
      return new Promise((resolve, reject) => {
        this.$api.get(`promocodes/${code}${targetType ? `?target_type=${targetType}` : ''}`)
          .then((response) => {
            const { promocode } = response.data;
            resolve(promocode);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    previewPromocode(code, targetType) {
      return new Promise((resolve, reject) => {
        this.getPromocode(code, targetType)
          .then((promocode) => {
            // this.promocode = promocode;
            this.$store.commit('SET_PREVIEW_PROMOCODE', promocode);
            resolve(promocode);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    clearPromocode() {
      this.promocode = new Promocode();
      this.$store.commit('SET_QUERY_CODE', null);
      this.$store.commit('SET_PREVIEW_PROMOCODE', null);
      this.$bus.$emit('promocode-cleared');
    },
    applyPromocode(code, subscription) {
      return new Promise((resolve, reject) => {
        this.$api.post('promocodes/apply', { promocode: code, subscription: subscription.payment_provider_subscription_id })
          .then((response) => {
            this.promocode = new Promocode();
            this.$store.commit('RESET_PROMOCODE');
            resolve(response);
          })
          .catch((error) => {
            this.promocode = new Promocode();
            this.$store.commit('RESET_PROMOCODE');
            reject(error);
          });
      });
    },
  },
  mounted() {
    if (this.queryCode !== null) {
      const query = { ...this.$route.query };
      query.promo = this.queryCode;
      this.$router.replace({ query })
        .then(() => {})
        .catch(() => {});
    }
  },
  computed: {
    ...mapState(['queryCode']),
  },
};
